import {
  SHOW_LOADER,
  HIDE_LOADER,
  SET_RESPONSE_MODAL,
  SET_AGENT_STAFF_ID,
  SET_AGENT_TABLE_ID,
} from 'store/actions/commons/types';

export const initialState = {
  loader: 0,
  responseModal: {
    show: false,
    success: false,
    error: false,
    title: '',
    message: '',
    customAction: null,
  },
  agentStaffId: null,
  agentTableId: null,
};

export const commonsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER:
      return {
        ...state,
        loader: state.loader + 1,
      };
    case HIDE_LOADER:
      return {
        ...state,
        loader: state.loader > 0 ? state.loader - 1 : 0,
      };
    case SET_RESPONSE_MODAL:
      return {
        ...state,
        responseModal: {
          ...state.state,
          ...action.payload,
        },
      };
    case SET_AGENT_STAFF_ID:
      return {
        ...state,
        agentStaffId: action.payload,
      };
    case SET_AGENT_TABLE_ID:
      return {
        ...state,
        agentTableId: action.payload,
      };
    default:
      return state;
  }
};
